import moment from "moment-timezone";
import { Component } from "vue-facing-decorator";
import { User } from "../../store/store";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { checkAccessRights } from "../../services/accessRightServices";
import { getPurchaseTypes, getSalesTypes } from "../../services/documentServices";
import { ComponentBase } from "../ComponentBase";

@Component
export class DocumentTableBase extends ComponentBase {
    get loading() {
        if (this.$apollo.queries.documents) {
            return this.$apollo.queries.documents.loading;
        }
        return false;
    }

    get currentUser(): User {
        //   debugger
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "document", "read");
        return authorized;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get declareSalesInvoices() {
        if (
            this.selectedCompany.incomeCategory === "BNC" &&
            isNotSubjectToVAT(this.selectedCompany.vatSystem)
        ) {
            return false;
        }
        return true;
    }

    get legalForm() {
        return this.selectedCompany.legalForm;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD MMM YYYY");
    }

    diffDueDate(document) {
        if (
            document.dueDate &&
            document.reconciliationStatus &&
            !document.reconciliationStatus.notReconciliatedAmountSigned
        ) {
            return moment(document.dueDate).diff(moment(), "days");
        }
        return undefined;
    }

    dueDateStatus(document) {
        const diff = this.diffDueDate(document);
        if (diff < 0) {
            return this.$t("document.dueDate.late", { diff: -diff }, -diff);
        }
        if (diff >= 0) {
            return this.$t("document.dueDate.wait", { diff: diff }, diff);
        }
        return "";
    }

    documentIcon(document) {
        if (!document.grossAmountSigned) {
            if (getPurchaseTypes().indexOf(document.type) !== -1) {
                return "trending_down";
            }
            if (getSalesTypes().indexOf(document.type) !== -1) return "trending_up";
            if (document.type === "PAY_SLIP") return "trending_down";
            if (document.type === "MISCELLANEOUS") return "description";
            return "";
        }
        if (document.grossAmountSigned < 0) return "trending_down";
        return "trending_up";
    }

    isOutlined(item) {
        const status = item.status;
        const reconciliation = item.reconciliation;
        // else {
        let result = true;
        if (reconciliation) {
            if (
                reconciliation.status === "PENDING_VALIDATION" ||
                reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT"
            ) {
                return false;
            }
        }
        if (status.startsWith("ANALYSED")) {
            result = false;
        }
        if (status === "INFORMATION_REQUEST") {
            result = false;
        }
        return result;
    }
}
